export enum InputSize {
	Auto = 'auto',
	Small = 'small',
	Medium = 'medium',
	Long = 'long',
}
